import type { RouterConfig } from '@nuxt/schema';
import { resolveInitialStudioRoutes } from '~/utils/resolve-initial-studio-routes';

export default {
	routes: resolveInitialStudioRoutes,
} satisfies RouterConfig;
